import React from 'react';
import { useShopItems } from '../../hooks/queries';

/**
 * 🟢 [方案B] 装备架（Loadout）
 *
 * 头像保持干净，已拥有的装备在这里以「填充彩色图标 + 名称」的 chip 排开展示，
 * 不再叠加到头像上，彻底避免堆叠糊在一起。名称从商店商品列表（React Query 缓存）
 * 反查，反查不到时用 id 兜底生成。
 */

const prettify = (id) =>
  String(id)
    .replace(/^item_/, '')
    .replace(/[_-]/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());

const norm = (id) => String(id).replace(/^item_/, '');

const EquipmentLoadout = ({ inventory = [], className = '', emptyHint = true }) => {
  const { data: shopItems = [] } = useShopItems();

  if (!inventory || inventory.length === 0) {
    return emptyHint ? (
      <div className={`text-sm text-gray-400 italic ${className}`}>
        No gear yet — visit the Shop to unlock items!
      </div>
    ) : null;
  }

  const items = inventory.map((invId) => {
    const found = shopItems.find((s) => s.id === invId || norm(s.id) === norm(invId));
    return found || { id: invId, name: prettify(invId), type: '' };
  });

  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {items.map((item) => (
        <div
          key={item.id}
          className="flex items-center gap-1.5 bg-white rounded-full pl-2.5 pr-3 py-1 shadow-sm border border-gray-100"
          title={item.name}
        >
          <span className="text-xl leading-none">{item.icon || '🎁'}</span>
          <span className="text-xs font-bold text-gray-700 capitalize whitespace-nowrap">{item.name}</span>
        </div>
      ))}
    </div>
  );
};

export default EquipmentLoadout;
